export default __webpack_public_path__ + "static/assets/im_search.4d4ae15f2b8512cfb975180ad2b89f63.png";